module.exports = __webpack_public_path__ + "img/Canada.1168715c.png";